// Generated by packages/design-tokens/scripts/generate.mjs from tokens.json. Do not edit.
export const tokens = {
  version: 1,
  color: {
    "bg.canvas": {
      light: "#FAF8F4",
      dark: "#1A1917",
    },
    "bg.surface": {
      light: "#FFFFFF",
      dark: "#22211E",
    },
    "bg.sidebar": {
      light: "#F3EFE7",
      dark: "#1F1E1B",
    },
    "bg.elevated": {
      light: "#FFFFFFCC",
      dark: "#2A2926CC",
    },
    "text.primary": {
      light: "#1D1C1A",
      dark: "#ECE9E3",
    },
    "text.secondary": {
      light: "#57544F",
      dark: "#B1ADA7",
    },
    "text.tertiary": {
      light: "#706B62",
      dark: "#95918A",
    },
    "text.onAccent": {
      light: "#FFFFFF",
      dark: "#1A1917",
    },
    "line.separator": {
      light: "#E6E1D8",
      dark: "#34322E",
    },
    accent: {
      light: "#2B58DA",
      dark: "#7B9BFF",
    },
    danger: {
      light: "#B43329",
      dark: "#FF6B5E",
    },
    success: {
      light: "#317047",
      dark: "#6BC48A",
    },
    warning: {
      light: "#855B12",
      dark: "#F2B54B",
    },
  },
  ink: {
    black: {
      light: "#1D1C1A",
      dark: "#ECE9E3",
    },
    blue: {
      light: "#2E5BDB",
      dark: "#7C99E9",
    },
    red: {
      light: "#D2453B",
      dark: "#E28983",
    },
    green: {
      light: "#3E8E5A",
      dark: "#94D1AA",
    },
    purple: {
      light: "#7A4FD6",
      dark: "#A183E2",
    },
    brown: {
      light: "#8A5A32",
      dark: "#D6AF8F",
    },
  },
  highlight: {
    yellow: {
      light: "#FFE36E80",
      dark: "#C8AE4166",
    },
    green: {
      light: "#9BE3A880",
      dark: "#41C85A66",
    },
    pink: {
      light: "#FFB3C780",
      dark: "#C8416566",
    },
    blue: {
      light: "#A9CCFF80",
      dark: "#4178C866",
    },
  },
  tint: {
    red: {
      fg: {
        light: "#BA3D34",
        dark: "#FF7B6E",
      },
      bg: {
        light: "#FBE7E4",
        dark: "#3A2321",
      },
    },
    orange: {
      fg: {
        light: "#A45617",
        dark: "#FFA24D",
      },
      bg: {
        light: "#FCEBDD",
        dark: "#3A2A1C",
      },
    },
    yellow: {
      fg: {
        light: "#88680A",
        dark: "#F2C94C",
      },
      bg: {
        light: "#FBF1CF",
        dark: "#383018",
      },
    },
    green: {
      fg: {
        light: "#34774C",
        dark: "#6BC48A",
      },
      bg: {
        light: "#E3F1E6",
        dark: "#1F3326",
      },
    },
    teal: {
      fg: {
        light: "#257473",
        dark: "#5CCFCF",
      },
      bg: {
        light: "#DDF0EF",
        dark: "#1C3333",
      },
    },
    blue: {
      fg: {
        light: "#2E5BDB",
        dark: "#7B9BFF",
      },
      bg: {
        light: "#E3EAFB",
        dark: "#1F2740",
      },
    },
    indigo: {
      fg: {
        light: "#4B4FC4",
        dark: "#9A9DFF",
      },
      bg: {
        light: "#E7E7F8",
        dark: "#26263F",
      },
    },
    purple: {
      fg: {
        light: "#774BD5",
        dark: "#B595FF",
      },
      bg: {
        light: "#EEE6FA",
        dark: "#2E2440",
      },
    },
    pink: {
      fg: {
        light: "#B43A70",
        dark: "#FF8DBF",
      },
      bg: {
        light: "#FAE4EE",
        dark: "#3A2230",
      },
    },
    gray: {
      fg: {
        light: "#6B6862",
        dark: "#A19D95",
      },
      bg: {
        light: "#EEEBE5",
        dark: "#2C2B28",
      },
    },
  },
  backdrop: {
    sand: {
      light: {
        angle: 160,
        base: ["#F7EFE2", "#EFE3CF"],
        blobs: [
          {
            color: "#F6D9B8",
            x: 18,
            y: 12,
            radius: 62,
          },
          {
            color: "#FBEFD9",
            x: 82,
            y: 24,
            radius: 54,
          },
          {
            color: "#E9D3C0",
            x: 60,
            y: 92,
            radius: 70,
          },
        ],
        noise: 0.05,
        css: "radial-gradient(circle at 18% 12%, #F6D9B8 0%, #F6D9B800 62%), radial-gradient(circle at 82% 24%, #FBEFD9 0%, #FBEFD900 54%), radial-gradient(circle at 60% 92%, #E9D3C0 0%, #E9D3C000 70%), linear-gradient(160deg, #F7EFE2, #EFE3CF)",
      },
      dark: {
        angle: 160,
        base: ["#26221C", "#1E1B17"],
        blobs: [
          {
            color: "#4A3A28",
            x: 18,
            y: 12,
            radius: 62,
          },
          {
            color: "#3A3024",
            x: 82,
            y: 24,
            radius: 54,
          },
          {
            color: "#33281F",
            x: 60,
            y: 92,
            radius: 70,
          },
        ],
        noise: 0.06,
        css: "radial-gradient(circle at 18% 12%, #4A3A28 0%, #4A3A2800 62%), radial-gradient(circle at 82% 24%, #3A3024 0%, #3A302400 54%), radial-gradient(circle at 60% 92%, #33281F 0%, #33281F00 70%), linear-gradient(160deg, #26221C, #1E1B17)",
      },
    },
    dusk: {
      light: {
        angle: 150,
        base: ["#EEE7F3", "#E4DDEE"],
        blobs: [
          {
            color: "#F3C9C4",
            x: 14,
            y: 18,
            radius: 60,
          },
          {
            color: "#C9C6F0",
            x: 84,
            y: 20,
            radius: 58,
          },
          {
            color: "#E8D2E6",
            x: 52,
            y: 96,
            radius: 72,
          },
        ],
        noise: 0.05,
        css: "radial-gradient(circle at 14% 18%, #F3C9C4 0%, #F3C9C400 60%), radial-gradient(circle at 84% 20%, #C9C6F0 0%, #C9C6F000 58%), radial-gradient(circle at 52% 96%, #E8D2E6 0%, #E8D2E600 72%), linear-gradient(150deg, #EEE7F3, #E4DDEE)",
      },
      dark: {
        angle: 150,
        base: ["#221F2A", "#1B1922"],
        blobs: [
          {
            color: "#4A2E36",
            x: 14,
            y: 18,
            radius: 60,
          },
          {
            color: "#2F2C52",
            x: 84,
            y: 20,
            radius: 58,
          },
          {
            color: "#3A2840",
            x: 52,
            y: 96,
            radius: 72,
          },
        ],
        noise: 0.06,
        css: "radial-gradient(circle at 14% 18%, #4A2E36 0%, #4A2E3600 60%), radial-gradient(circle at 84% 20%, #2F2C52 0%, #2F2C5200 58%), radial-gradient(circle at 52% 96%, #3A2840 0%, #3A284000 72%), linear-gradient(150deg, #221F2A, #1B1922)",
      },
    },
    mist: {
      light: {
        angle: 170,
        base: ["#EEF2F4", "#E3EAEE"],
        blobs: [
          {
            color: "#D3E3F0",
            x: 20,
            y: 14,
            radius: 60,
          },
          {
            color: "#E6EEF0",
            x: 80,
            y: 30,
            radius: 56,
          },
          {
            color: "#CFDDE3",
            x: 46,
            y: 94,
            radius: 72,
          },
        ],
        noise: 0.05,
        css: "radial-gradient(circle at 20% 14%, #D3E3F0 0%, #D3E3F000 60%), radial-gradient(circle at 80% 30%, #E6EEF0 0%, #E6EEF000 56%), radial-gradient(circle at 46% 94%, #CFDDE3 0%, #CFDDE300 72%), linear-gradient(170deg, #EEF2F4, #E3EAEE)",
      },
      dark: {
        angle: 170,
        base: ["#1C2024", "#171A1E"],
        blobs: [
          {
            color: "#253445",
            x: 20,
            y: 14,
            radius: 60,
          },
          {
            color: "#22292E",
            x: 80,
            y: 30,
            radius: 56,
          },
          {
            color: "#1F2E33",
            x: 46,
            y: 94,
            radius: 72,
          },
        ],
        noise: 0.06,
        css: "radial-gradient(circle at 20% 14%, #253445 0%, #25344500 60%), radial-gradient(circle at 80% 30%, #22292E 0%, #22292E00 56%), radial-gradient(circle at 46% 94%, #1F2E33 0%, #1F2E3300 72%), linear-gradient(170deg, #1C2024, #171A1E)",
      },
    },
    meadow: {
      light: {
        angle: 155,
        base: ["#EEF3E6", "#E2EBD9"],
        blobs: [
          {
            color: "#CFE6C4",
            x: 16,
            y: 16,
            radius: 62,
          },
          {
            color: "#F1EDC9",
            x: 84,
            y: 22,
            radius: 54,
          },
          {
            color: "#C9E0D4",
            x: 56,
            y: 94,
            radius: 70,
          },
        ],
        noise: 0.05,
        css: "radial-gradient(circle at 16% 16%, #CFE6C4 0%, #CFE6C400 62%), radial-gradient(circle at 84% 22%, #F1EDC9 0%, #F1EDC900 54%), radial-gradient(circle at 56% 94%, #C9E0D4 0%, #C9E0D400 70%), linear-gradient(155deg, #EEF3E6, #E2EBD9)",
      },
      dark: {
        angle: 155,
        base: ["#1D211A", "#181B16"],
        blobs: [
          {
            color: "#2C3D27",
            x: 16,
            y: 16,
            radius: 62,
          },
          {
            color: "#38361F",
            x: 84,
            y: 22,
            radius: 54,
          },
          {
            color: "#21362D",
            x: 56,
            y: 94,
            radius: 70,
          },
        ],
        noise: 0.06,
        css: "radial-gradient(circle at 16% 16%, #2C3D27 0%, #2C3D2700 62%), radial-gradient(circle at 84% 22%, #38361F 0%, #38361F00 54%), radial-gradient(circle at 56% 94%, #21362D 0%, #21362D00 70%), linear-gradient(155deg, #1D211A, #181B16)",
      },
    },
    ember: {
      light: {
        angle: 145,
        base: ["#F8EAE3", "#F1DDD3"],
        blobs: [
          {
            color: "#F7C3A8",
            x: 14,
            y: 14,
            radius: 60,
          },
          {
            color: "#F8DDC0",
            x: 86,
            y: 26,
            radius: 56,
          },
          {
            color: "#EDB9B4",
            x: 50,
            y: 96,
            radius: 70,
          },
        ],
        noise: 0.05,
        css: "radial-gradient(circle at 14% 14%, #F7C3A8 0%, #F7C3A800 60%), radial-gradient(circle at 86% 26%, #F8DDC0 0%, #F8DDC000 56%), radial-gradient(circle at 50% 96%, #EDB9B4 0%, #EDB9B400 70%), linear-gradient(145deg, #F8EAE3, #F1DDD3)",
      },
      dark: {
        angle: 145,
        base: ["#2A1F1B", "#211916"],
        blobs: [
          {
            color: "#55301F",
            x: 14,
            y: 14,
            radius: 60,
          },
          {
            color: "#4A3522",
            x: 86,
            y: 26,
            radius: 56,
          },
          {
            color: "#472624",
            x: 50,
            y: 96,
            radius: 70,
          },
        ],
        noise: 0.06,
        css: "radial-gradient(circle at 14% 14%, #55301F 0%, #55301F00 60%), radial-gradient(circle at 86% 26%, #4A3522 0%, #4A352200 56%), radial-gradient(circle at 50% 96%, #472624 0%, #47262400 70%), linear-gradient(145deg, #2A1F1B, #211916)",
      },
    },
  },
  font: {
    display: {
      ios: "New York",
      web: [
        "Source Serif 4 Variable",
        "Source Serif 4",
        "ui-serif",
        "New York",
        "Georgia",
        "serif",
      ],
    },
    text: {
      ios: "SF Pro Text",
      web: [
        "Inter Variable",
        "Inter",
        "ui-sans-serif",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "sans-serif",
      ],
    },
    mono: {
      ios: "SF Mono",
      web: [
        "JetBrains Mono Variable",
        "JetBrains Mono",
        "ui-monospace",
        "SF Mono",
        "Menlo",
        "monospace",
      ],
    },
  },
  type: {
    title: {
      size: 34,
      weight: 600,
      font: "display",
      lineHeight: 1.2,
      tracking: -0.4,
      textStyle: "largeTitle",
    },
    h1: {
      size: 28,
      weight: 600,
      font: "display",
      lineHeight: 1.2,
      tracking: -0.3,
      textStyle: "title",
    },
    h2: {
      size: 22,
      weight: 600,
      font: "display",
      lineHeight: 1.2,
      tracking: -0.2,
      textStyle: "title2",
    },
    h3: {
      size: 19,
      weight: 600,
      font: "display",
      lineHeight: 1.2,
      tracking: -0.1,
      textStyle: "title3",
    },
    body: {
      size: 17,
      weight: 400,
      font: "text",
      lineHeight: 1.5,
      tracking: -0.2,
      textStyle: "body",
    },
    callout: {
      size: 16,
      weight: 400,
      font: "text",
      lineHeight: 1.5,
      tracking: -0.2,
      textStyle: "callout",
    },
    footnote: {
      size: 13,
      weight: 400,
      font: "text",
      lineHeight: 1.5,
      tracking: 0,
      textStyle: "footnote",
    },
    caption: {
      size: 12,
      weight: 500,
      font: "text",
      lineHeight: 1.5,
      tracking: 0,
      textStyle: "caption",
    },
  },
  space: {
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    7: 28,
    8: 32,
    9: 36,
    10: 40,
  },
  radius: {
    sm: 6,
    md: 10,
    lg: 14,
    xl: 20,
    full: 9999,
  },
  shadow: {
    card: {
      light: [
        {
          x: 0,
          y: 1,
          blur: 2,
          spread: 0,
          color: "#1D1C1A0D",
        },
        {
          x: 0,
          y: 8,
          blur: 24,
          spread: -6,
          color: "#1D1C1A14",
        },
      ],
      dark: [
        {
          x: 0,
          y: 1,
          blur: 2,
          spread: 0,
          color: "#00000040",
        },
        {
          x: 0,
          y: 8,
          blur: 24,
          spread: -6,
          color: "#00000059",
        },
      ],
    },
    popover: {
      light: [
        {
          x: 0,
          y: 2,
          blur: 6,
          spread: 0,
          color: "#1D1C1A0F",
        },
        {
          x: 0,
          y: 18,
          blur: 48,
          spread: -8,
          color: "#1D1C1A29",
        },
      ],
      dark: [
        {
          x: 0,
          y: 2,
          blur: 6,
          spread: 0,
          color: "#00000059",
        },
        {
          x: 0,
          y: 18,
          blur: 48,
          spread: -8,
          color: "#0000008C",
        },
      ],
    },
  },
  width: {
    normal: 720,
    wide: 960,
    full: null,
  },
  motion: {
    snappy: {
      response: 0.3,
      damping: 0.85,
      css: {
        duration: 419,
        easing:
          "linear(0, 0.0151, 0.0543, 0.1102, 0.1766, 0.2489, 0.3234, 0.3974, 0.4688, 0.5364, 0.5993, 0.6568, 0.7088, 0.7552, 0.7963, 0.8322, 0.8633, 0.89, 0.9128, 0.9319, 0.9479, 0.9612, 0.972, 0.9807, 0.9876, 0.9931, 0.9972, 1.0004, 1.0027, 1.0043, 1.0053, 1.006, 1.0062, 1.0063, 1.0061, 1.0058, 1.0054, 1.005, 1.0045, 1.0041, 1.0036, 1.0032, 1.0028, 1.0024, 1.002, 1.0017, 1.0014, 1.0012, 1)",
      },
      web: {
        type: "spring",
        visualDuration: 0.3,
        bounce: 0.15,
      },
    },
    smooth: {
      response: 0.45,
      damping: 0.9,
      css: {
        duration: 600,
        easing:
          "linear(0, 0.0137, 0.0495, 0.1003, 0.161, 0.2271, 0.2956, 0.364, 0.4305, 0.494, 0.5535, 0.6086, 0.6591, 0.7048, 0.746, 0.7826, 0.815, 0.8436, 0.8685, 0.8901, 0.9088, 0.9248, 0.9384, 0.95, 0.9598, 0.9679, 0.9747, 0.9804, 0.985, 0.9888, 0.9918, 0.9943, 0.9962, 0.9977, 0.9989, 0.9997, 1.0004, 1.0009, 1.0012, 1.0014, 1.0015, 1.0015, 1.0015, 1.0015, 1.0014, 1.0013, 1.0012, 1.0011, 1)",
      },
      web: {
        type: "spring",
        visualDuration: 0.45,
        bounce: 0.1,
      },
    },
    gentle: {
      response: 0.6,
      damping: 1,
      css: {
        duration: 882,
        easing:
          "linear(0, 0.0163, 0.0575, 0.1145, 0.1804, 0.2503, 0.3209, 0.3897, 0.4553, 0.5166, 0.5731, 0.6246, 0.6712, 0.713, 0.7502, 0.7832, 0.8123, 0.8379, 0.8602, 0.8797, 0.8967, 0.9114, 0.9241, 0.9351, 0.9445, 0.9527, 0.9597, 0.9657, 0.9708, 0.9752, 0.9789, 0.9821, 0.9848, 0.9872, 0.9891, 0.9908, 0.9922, 0.9934, 0.9945, 0.9953, 0.996, 0.9967, 0.9972, 0.9976, 0.998, 0.9983, 0.9986, 0.9988, 1)",
      },
      web: {
        type: "spring",
        visualDuration: 0.6,
        bounce: 0,
      },
    },
  },
  duration: {
    fast: 120,
    base: 200,
    slow: 320,
  },
  haptic: {
    selection: "selection",
    taskComplete: "success",
    delete: "warning",
  },
};

export const colorNames = Object.keys(tokens.color);
export const inkNames = Object.keys(tokens.ink);
export const highlightNames = Object.keys(tokens.highlight);
export const tintNames = Object.keys(tokens.tint);
export const backdropNames = Object.keys(tokens.backdrop);

/** CSS custom property for a token, e.g. cssVar("color", "bg.canvas") -> var(--ds-bg-canvas). */
export function cssVar(group, name, part) {
  const n = name
    .replace(/\./g, "-")
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .toLowerCase();
  if (group === "color") return `var(--ds-${n})`;
  if (group === "tint") return `var(--ds-tint-${n}-${part ?? "fg"})`;
  return `var(--ds-${group}-${n})`;
}
